import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Rail, Sticky, Grid, Card, Image, Ref, Icon, Divider } from "semantic-ui-react";
import ReservationCard from "../../components/ReservationCard/ReservationCard";
import Section1 from "../../containers/PropertyPage/Section1/Section1"
import Section2 from "../../containers/PropertyPage/Section2/Section2"
import Section3 from "../../containers/PropertyPage/Section3/Section3";
import "./PropertyPage.css"

const PropertyPage = () => {
    const [fixed, setFixed] = useState(false)
    const isRtl = useSelector((state) => state.main.isRtl)
    const contextRef = useRef(null)
    const onChange = (isVisible) => {
        isVisible ? setFixed(false) : setFixed(true)
        console.log('Element is now %s', isVisible ? 'visible' : 'hidden');
    }

    return (
        <div className="main-cls">
            <Container fluid className="p-1 m-1-t m-5-b">

                <Section1 visibilyChange={onChange} />

                <Container className="m-5-b">
                    <div className="desktop-view">
                        <Grid  columns={2}>
                            <Grid.Column  width={10}>
                                <Ref innerRef={contextRef}>
                                    <Container>
                                        <Rail position={isRtl ? 'right' : 'left'} className="w-60 p-0 m-3-t m-3-b">
                                            <Sticky context={contextRef} offset={100}>
                                                <ReservationCard />
                                            </Sticky>
                                        </Rail>
                                        <Section2 fixed={fixed} />
                                    </Container>
                                </Ref>
                            </Grid.Column>
                        </Grid>
                    </div>

                    <div className="tablet-view">
                        <Section2 fixed={fixed} />
                    </div>
                </Container>
                <Divider/>
                <Section3/>
            </Container>
        </div>
    )
}
export default PropertyPage